import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Play, Pause, Plus } from 'lucide-react';

export default function RetroTimer({ totalSeconds, startedAt, pausedAt, extraSeconds = 0, isFacilitator, isLocked = false, onAction }) {
  const [display, setDisplay] = useState(totalSeconds);
  const intervalRef = useRef(null);

  const calcRemaining = useCallback(() => {
    if (!startedAt) return totalSeconds + extraSeconds;
    const start = new Date(startedAt).getTime();
    const now = Date.now();
    let elapsed;
    if (pausedAt) {
      elapsed = new Date(pausedAt).getTime() - start;
    } else {
      elapsed = now - start;
    }
    return Math.max(0, totalSeconds + extraSeconds - Math.floor(elapsed / 1000));
  }, [startedAt, pausedAt, totalSeconds, extraSeconds]);

  useEffect(() => {
    const update = () => setDisplay(calcRemaining());
    update();
    if (startedAt && !pausedAt) {
      intervalRef.current = setInterval(update, 1000);
    }
    return () => clearInterval(intervalRef.current);
  }, [calcRemaining, startedAt, pausedAt]);

  const mins = Math.floor(display / 60);
  const secs = display % 60;
  const pct = (totalSeconds + extraSeconds) > 0 ? display / (totalSeconds + extraSeconds) : 0;
  const colorClass = pct > 0.5 ? 'ok' : pct > 0.2 ? 'warn' : 'danger';
  const isRunning = !!startedAt && !pausedAt;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <div className={`timer-display ${colorClass}`}>
        {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
      </div>
      {isFacilitator && (
        <div className="flex gap-2">
          {!startedAt ? (
            <button className="btn btn-success btn-sm" onClick={() => onAction('start')} disabled={isLocked} title={isLocked ? 'Board is locked' : undefined}><Play size={12} /> Start</button>
          ) : isRunning ? (
            <button className="btn btn-secondary btn-sm" onClick={() => onAction('pause')}><Pause size={12} /> Pause</button>
          ) : (
            <button className="btn btn-success btn-sm" onClick={() => onAction('resume')}><Play size={12} /> Resume</button>
          )}
          <button className="btn btn-ghost btn-sm" onClick={() => onAction('add30')} title="+30 seconds">
            <Plus size={12} /> 30s
          </button>
        </div>
      )}
      {display === 0 && startedAt && (
        <span className="badge badge-yellow pulse">⏰ Time's up!</span>
      )}
      {display === 0 && startedAt && isFacilitator && (
        <button className="btn btn-success btn-sm" onClick={() => onAction('start')} style={{ marginLeft: 8 }}>
          <Play size={12} /> Restart
        </button>
      )}
    </div>
  );
}
